import { StompConfig } from '@stomp/ng2-stompjs';
import { Observable } from 'rxjs';

// var configs:any=Constants.setStompConfig();

// console.log("config rx-stomp==>", typeof configs)
export const stompConfig: StompConfig = {
  // Which server?
  // brokerURL: 'ws:' + ((Constants.Var.BASE_URL) != null ? '//' + (Constants.Var.BASE_URL) : '' + ':15674/ws',
 
  url:'',//Constants.setStompConfig('url'),
  // Headers
  // Typical keys: login, passcode, host
  headers: {
    login: '',//Constants.setStompConfig('loginName'),
    passcode: '',//Constants.setStompConfig('passcode')
  },

  // How often to heartbeat?
  // Interval in milliseconds, set to 0 to disable
  heartbeat_in: 0, // Typical value 0 - disabled
  heartbeat_out: 20000, // Typical value 20000 - every 20 seconds

  // Wait in milliseconds before attempting auto reconnect
  // Set to 0 to disable
  // Typical value 500 (500 milli seconds)
  reconnect_delay: 2000,

  // Will log diagnostics on console
  // It can be quite verbose, not recommended in production
  // Skip this key to stop logging to console
  debug: true
};


// WEBPACK FOOTER //
// ./src/app/models/rx-stomp-config.ts